type RuntimeEnv = {
  HOST: string;
  GA: string;
  GTM_ID: string;
  DOMAIN_SPLIT: string;
};

export const env = (window as any).__ENV__ as RuntimeEnv;

